import React from 'react'

import MoreArrow from '../Helper/MoreArrow'

const styles = {
    mainWrapper: "grid grid-cols-1 lg:grid-cols-2 sm:w-full",
    leftWrapper: "flex justify-start text-[#333333]",
    rightWrapper: "flex justify-end items-start md:items-center lg:items-start flex-col text-[#333333]",
    rightContainer: "flex flex-col justify-center items-start lg:items-center 2xl:text-lg",
    leftContainer: "flex flex-col justify-start items-start",
    textContainer: "sm:w-11/12  flex items-center sm:centerContent",
  };

const TopSection = ({projectDetails}) => {
  return (
    <>
        <div className={styles.mainWrapper}>
            {/* Left Side */}
            <div className={styles.leftWrapper}>
                <div className={styles.leftContainer}>
                    <div>
                        <h1 className="font-bold md:text-5xl capitalize">{projectDetails.mainHeading}</h1>
                    </div>
                    <div className="flex flex-col mt-16">
                        <p className="mb-[-1em]">Website design & Branding</p>
                        <MoreArrow text={projectDetails.TEXT} />
                    </div>
                </div>
            </div>

            {/* Right Side */}
            <div className={styles.rightWrapper.concat(" mt-6 lg:mt-0")}>
                <div className={styles.rightContainer}>
                    <div className={styles.textContainer}>
                        <h2 className="font-semibold text-2xl">Project Overview:</h2>
                    </div>
                    <div className={styles.textContainer.concat(" mt-5")}>
                        <p className="text-[#333333]/70">{projectDetails.projectOverview}</p>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default TopSection